export default __webpack_public_path__ + "49da6a2153f62ef73d17af59897ff481.svg";